import { render, staticRenderFns } from "./EditContentComponent.vue?vue&type=template&id=44862327&scoped=true"
import script from "./EditContentComponent.vue?vue&type=script&lang=js"
export * from "./EditContentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44862327",
  null
  
)

export default component.exports